import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

const WEATHER_PARAM = ":id?";
const WEATHER_PATH = "/weather";
const WEATHER_SEARCH = "search";
const WEATHER_WITH_STATION = `${WEATHER_PATH}/${WEATHER_PARAM}`;

export const WeatherRoutes = {
    WeatherParam: WEATHER_PARAM,
    Weather: WEATHER_PATH,
    Search: WEATHER_SEARCH,
    WeatherWithStation: WEATHER_WITH_STATION,
    SEARCH_MOBILE: WEATHER_SEARCH,

    WEATHER: (id?: string): string =>
        id ? WEATHER_WITH_STATION.replace(WEATHER_PARAM, id) : WEATHER_PATH,
} as const;

export const weatherRoutes = (
    <Route
        path={`${WeatherRoutes.Weather}/${WeatherRoutes.WeatherParam}`}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { WeatherModuleLayout } =
                await import("@weather/presentation/layout/weather-module.layout.tsx");
            return { Component: WeatherModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { WeatherPage } =
                    await import("@weather/presentation/pages/weather/weather.page.tsx");
                return { Component: WeatherPage };
            }}
        />
        <Route
            path={WeatherRoutes.Search}
            lazy={async () => {
                const { WeatherSearchMobilePage } =
                    await import("@weather/presentation/pages/weather/mobile/search/weather-search-mobile.page.tsx");
                return {
                    Component: WeatherSearchMobilePage,
                };
            }}
        />
    </Route>
);
